export function routeInList(list: Array<string>, pathname: string): boolean {
    return list.reduce((result, path) => {
        return result || (path.startsWith(':') ? pathname === path.substring(1) : pathname.startsWith(path));
    }, false);
}